import { render, staticRenderFns } from "./UserRequestFreezer.vue?vue&type=template&id=35122596&"
import script from "./UserRequestFreezer.vue?vue&type=script&lang=js&"
export * from "./UserRequestFreezer.vue?vue&type=script&lang=js&"
import style0 from "./UserRequestFreezer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports